/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



 var date=new Date();
  var months=["JAN","FEB","MAR","APR","MAY","JUN","JUL",
              "AUG","SEP","OCT","NOV","DEC"];
  var val=months[date.getMonth()]+" "+date.getDate()+" "+date.getFullYear();
  var time_val;
  var countDownDate;
 

  $( document ).ready(function() {
    time_val = $("#time_date").html();
    console.log(time_val);
    countDownDate = new Date(val+ " " +time_val);
    count(countDownDate);
  });
  function count(countDownDate){
    var x = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      document.getElementById("countdown").innerHTML = "<div class='timer_main'>"+"<div class='time'>"+"<h4>" + (hours<10 ? "0" + hours : hours) +": </h4></div>"+"<div class='time'>"+"<h4>" + (minutes<10 ? "0" + minutes : minutes) +":</h4></div>"+"<div class='time'>"+"<h4>" + (seconds<10 ? "0" + seconds : seconds) +"</h4></div></div>";
    
      if (distance < 0) {
        clearInterval(x);
        var date=new Date();
        var months=["JAN","FEB","MAR","APR","MAY","JUN","JUL",
                    "AUG","SEP","OCT","NOV","DEC"];
        var val=months[date.getMonth()]+" "+date.getDate()+" "+date.getFullYear();
        var time_val = $("#time_date").html();
        var tomorrow= new Date(val+ " " +time_val);
        tomorrow.setDate(tomorrow.getDate() + 1);
        var new_date = tomorrow.getTime();
        extenddate(new_date);
      }
    });
  }
  function extenddate(date){
    count(date);
  }